
	<div class="spinner-border text-primary avatar-s" role="status">
		<span class="visually-hidden">Loading...</span>
	</div>
